import React from "react";
import { connect } from "react-redux";
import { Container, Dimmer, Loader, Message } from "semantic-ui-react";
import _ from "lodash";
import { observationsOperations } from "../../redux/observations";
import ObservationComments from "./components/ObservationComments";
import ObservationsOverview from "./components/ObservationsOverview";
import ObservationsHeader from "../../components/SRHHeaders/ObservationsHeader";
import Tabs from "../../components/Tabs";
import { ObservationsPage, PageContent } from "./style.js";

class Observations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      observations: [],
      start: props.observationsStart,
      end: props.observationsEnd,
      domainMap: {
        Briefing: "brief",
        "Inquiry & Rebriefing": "inq",
        "Assertion & Challenge": "assert",
        "Structured Communication": "struccom",
        "Closing the Loop": "loop",
        Debriefing: "debrief",
      },
      observationAreas: [],
      observers: [],
      domains: [],
      ratings: [],
    };
    this.handleStateChange = this.handleStateChange.bind(this);
    this.props.dispatch(observationsOperations.fetchObservations(this.state.start, this.state.end));
  }

  componentWillReceiveProps(nextProps) {
    const observations = this.filterObservations(nextProps);
    const counts = this.getCounts(nextProps, observations);
    this.setState({
      observations,
      observationAreaCounts: counts.observationAreaCounts,
      observerCounts: counts.observerCounts,
      start: nextProps.observationsStart,
    });
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.start !== nextState.start || this.state.end !== nextState.end) {
      this.props.dispatch(observationsOperations.fetchObservations(nextState.start, nextState.end));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.observationAreas !== this.state.observationAreas ||
      prevState.observers !== this.state.observers ||
      prevState.domains !== this.state.domains ||
      prevState.ratings !== this.state.ratings
    ) {
      const observations = this.filterObservations(this.props);
      const counts = this.getCounts(this.props, observations);
      this.setState({
        observations,
        observationAreaCounts: counts.observationAreaCounts,
        observerCounts: counts.observerCounts,
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(observationsOperations.clearObservations());
  }

  filterObservations(props) {
    return _.filter(props.observations, observation => {
      let domainFilter = true;
      if (this.state.domains.length > 0) {
        domainFilter = false;
        for (let i = 0; i < this.state.domains.length; i++) {
          if (observation[`${this.state.domainMap[this.state.domains[i]]}Rate`]) {
            domainFilter = true;
          }
        }
      }
      let ratingFilter = true;
      if (this.state.ratings.length > 0) {
        ratingFilter = false;
        for (let i = 0; i < this.state.ratings.length; i++) {
          if (this.state.domains.length > 0) {
            for (let j = 0; j < this.state.domains.length; j++) {
              if (observation[`${this.state.domainMap[this.state.domains[j]]}Rate`] === this.state.ratings[i]) {
                ratingFilter = true;
              }
            }
          } else {
            const domains = _.toPairs(this.state.domainMap);
            for (let j = 0; j < domains.length; j++) {
              if (observation[`${domains[j][1]}Rate`] === this.state.ratings[i]) {
                ratingFilter = true;
              }
            }
          }
        }
      }
      return (
        (this.state.observationAreas.length < 1 || _.includes(this.state.observationAreas, observation.obsArea)) &&
        (this.state.observers.length < 1 || _.includes(this.state.observers, observation.obsName)) &&
        domainFilter &&
        ratingFilter
      );
    });
  }

  getCounts(props, observations) {
    const observationAreaCounts = {};
    const observerCounts = {};
    for (let i = 0; i < props.observationAreas.length; i++) {
      observationAreaCounts[props.observationAreas[i]] = 0;
    }
    for (let i = 0; i < props.observerNames.length; i++) {
      observerCounts[props.observerNames[i]] = 0;
    }
    for (let i = 0; i < observations.length; i++) {
      const observation = observations[i];
      observationAreaCounts[observation.obsArea] += 1;
      observerCounts[observation.obsName] += 1;
    }
    return { observationAreaCounts, observerCounts };
  }

  handleStateChange(name, value) {
    const state = {
      [name]: value,
    };
    if (name === "domain" && !value) {
      state.rating = null;
    }
    this.setState(state);
  }

  render() {
    return (
      <ObservationsPage>
        <ObservationsHeader {...this.props} />
        {this.props.observationsFetched &&
          !this.props.error && (
            <PageContent>
              <Tabs tabs={["Overview", "Comments"]}>
                <ObservationsOverview handleStateChange={this.handleStateChange} state={this.state} {...this.props} />
                <ObservationComments handleStateChange={this.handleStateChange} state={this.state} {...this.props} />
              </Tabs>
            </PageContent>
          )}
        {!this.props.observationsFetched &&
          !this.props.error && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
        {this.props.error && (
          <Container style={{ paddingTop: "28px" }}>
            <Message
              error
              header="There was an error loading observation data"
              content={`${this.props.error.status} (${this.props.error.statusText})`}
            />
          </Container>
        )}
      </ObservationsPage>
    );
  }
}

export default connect(store => {
  return {
    title: store.observations.title,
    observations: store.observations.data,
    observationAreas: store.observations.observationAreas,
    observerNames: store.observations.observers,
    observationsFirst: store.observations.first,
    observationsStart: store.observations.start,
    observationsEnd: store.observations.end,
    observationsFetched: store.observations.fetched,
    error: store.observations.error,
  };
})(Observations);



// WEBPACK FOOTER //
// ./src/pages/Observations/index.jsx